module.exports = __webpack_public_path__ + "assets/webgl/art_069_L0.jpg.dxt.13e90bb1.ktx";